import "./App.css";
import { HashRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Home from "./pages/Home";

function App() {
  return <HashRouter><NavBar /><Routes><Route path="/" element={<Home />} /><Route path="*" element={<Home />} /></Routes></HashRouter>;
}

function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  function scrollToSection(id) {
    if (location.pathname !== "/") {
      navigate("/");
      window.setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 50);
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }
  return <header className="site-header">
    <button className="wordmark" onClick={() => scrollToSection("top")} aria-label="Back to top">CF<span>.</span></button>
    <nav className="site-nav" aria-label="Main navigation">
      <button onClick={() => scrollToSection("projects")}>Work</button>
      <button onClick={() => scrollToSection("career")}>Career</button>
    </nav>
  </header>;
}

export default App;
